module.exports = __webpack_public_path__ + "img/car-2.8c6a2239.svg";